import React from 'react';
import { View } from 'react-native';
import { Text } from '~/components';

import type { SvgProps } from 'react-native-svg';

interface Props {
  icon: React.FC<SvgProps>;
}

const Footer: React.FC<Props> = ({ icon: Icon }) => {
  return (
    <View className="items-center justify-center">
      <Text className="text-xs text-gray-400 mt-1 mb-6">
        Seguro administrado por:
      </Text>

      <Icon />
    </View>
  );
};

export default Footer;
